module.exports = __webpack_public_path__ + "static/media/express.d5f66342.png";